/**
 * Voice Profile API service for admin interface
 * Handles CRUD operations for voice profiles
 */

import type { VoiceProfile } from '@musedrops/shared';
import {
  listVoiceProfiles,
  updateVoiceProfile as updateVoiceProfileRecord,
  getVoiceProfileByKey as fetchVoiceProfileByKey,
} from '../data/voice-profile';

export interface VoiceProfileUpdateRequest {
  modelVoices: Record<string, string>;
}

class VoiceProfileApiService {
  /**
   * Get all voice profiles
   */
  static async getVoiceProfiles(): Promise<VoiceProfile[]> {
    return listVoiceProfiles();
  }

  /**
   * Update voice profile mappings
   */
  static async updateVoiceProfile(
    id: string,
    updates: VoiceProfileUpdateRequest
  ): Promise<VoiceProfile> {
    return updateVoiceProfileRecord(id, { modelVoices: updates.modelVoices });
  }

  /**
   * Bulk update all voice profiles
   */
  static async bulkUpdateVoiceProfiles(
    updates: Array<{ id: string; modelVoices: Record<string, string> }>
  ): Promise<VoiceProfile[]> {
    const promises = updates.map(update =>
      VoiceProfileApiService.updateVoiceProfile(update.id, {
        modelVoices: update.modelVoices,
      })
    );
    return Promise.all(promises);
  }

  /**
   * Get voice profile by key
   */
  static async getVoiceProfileByKey(key: string): Promise<VoiceProfile | null> {
    return fetchVoiceProfileByKey(key);
  }
}

export const voiceProfileApi = VoiceProfileApiService;
